import { forwardRef } from 'react'
import classNames from 'classnames'
import type { ComponentPropsWithRef } from 'react'
import type { CommonProps } from '../@types/common'

export interface THeadProps extends ComponentPropsWithRef<'thead'>, CommonProps {}

const THead = forwardRef<HTMLTableSectionElement, THeadProps>((props, ref) => {
    const { children, className, ...rest } = props

    const theadClass = classNames(className)

    return (
        <thead ref={ref} className={theadClass} {...rest}>
            {children}
        </thead>
    )
})

THead.displayName = 'THead'

export default THead 